import { mutator } from 'satcheljs';
import PolicyFetchRequestStatus from '../store/schema/PolicyFetchRequestStatus';
import {
    onActivePoliciesRequestSent,
    onActivePoliciesRequestComplete,
    onActivePoliciesRequestError,
} from '../actions/internalActions';
import getActivePoliciesListState from '../selectors/getActivePoliciesListState';

mutator(onActivePoliciesRequestSent, () => {
    getActivePoliciesListState().fetchRequestStatus = PolicyFetchRequestStatus.Pending;
});

mutator(onActivePoliciesRequestComplete, () => {
    getActivePoliciesListState().fetchRequestStatus = PolicyFetchRequestStatus.Complete;
});

mutator(onActivePoliciesRequestError, () => {
    getActivePoliciesListState().fetchRequestStatus = PolicyFetchRequestStatus.Error;
});
